import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-waitting2",
  "use": "icon-waitting2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-waitting2\"><defs><style type=\"text/css\"></style></defs><path d=\"M505.675294 30.960941a474.473412 474.473412 0 0 0 0 948.946824 474.473412 474.473412 0 0 0 0-948.946824z m200.58353 555.971765H470.317176a39.514353 39.514353 0 0 1-39.514352-39.514353V249.133176a39.514353 39.514353 0 1 1 79.028705 0v258.770824h196.427295a39.574588 39.574588 0 1 1 0 79.088941z\" p-id=\"9119\" fill=\"#e6a23c\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/waitting2.svg
// module id = sO3H
// module chunks = 148